export default __webpack_public_path__ + "static/media/Report (2).9fbc7e62.png";